import DeltaCounts from "components/DeltaCounts";
import ViewHeaderNavigation from "components/ViewHeader/Navigation";
import Tab from "ds/components/Tab";
import Typography from "ds/components/Typography";
import useTypedContext from "hooks/useTypedContext";
import { Delta, RunType } from "types/generated";
import { isModuleRunType } from "utils/run";
import { RunContext } from "components/Run/Context";
import { runHasChanges } from "components/Run/helpers";

const RunHeaderNonDetailedChangesNav = () => {
  const { run } = useTypedContext(RunContext);

  const isTask = run.type === RunType.Task;
  const isStackRun = !isTask && !isModuleRunType(run.type);
  const hasChanges = !!run.delta && runHasChanges(run.delta);
  const hasPluginOutputs = run.pluginLogs && run.pluginLogs.length > 0;

  return (
    <ViewHeaderNavigation>
      <Tab end label="History" to=".." />

      {isStackRun && !!run.delta && !hasChanges && (
        <Typography variant="p-t7" tag="div" margin="0 medium">
          No changes
        </Typography>
      )}

      {isStackRun && hasChanges && !!run.delta?.addCount && (
        <Tab
          to="../changes/add"
          label="Add"
          suffixComponent={
            <DeltaCounts
              delta={{ addCount: run.delta.addCount } as Delta}
              skipEmpty
              variant="flexible"
              size="small"
            />
          }
        />
      )}

      {isStackRun && hasChanges && !!run.delta?.changeCount && (
        <Tab
          to="../changes/change"
          label="Change"
          suffixComponent={
            <DeltaCounts
              delta={{ changeCount: run.delta.changeCount } as Delta}
              skipEmpty
              variant="flexible"
              size="small"
            />
          }
        />
      )}

      {isStackRun && hasChanges && !!run.delta?.deleteCount && (
        <Tab
          to="../changes/delete"
          label="Delete"
          suffixComponent={
            <DeltaCounts
              delta={{ deleteCount: run.delta.deleteCount } as Delta}
              skipEmpty
              variant="flexible"
              size="small"
            />
          }
        />
      )}
      {hasPluginOutputs && <Tab label="Plugin Outputs" to="../plugin-outputs" />}
    </ViewHeaderNavigation>
  );
};

export default RunHeaderNonDetailedChangesNav;
